import * as React from 'react'

import { Copy } from '@mondough/copy'

import { captureSharedTabsException } from '../../utils'
import styles from './ErrorBoundary.module.scss'

type ErrorState = { error: Error | null | undefined }

type Props = {
  children: React.ReactNode
}

const ErrorText = () => {
  return (
    <div className={styles.error}>
      <h2>
        <Copy.Simple
          id="app_tabs_monzo_me.common.error.title"
          fallback="Woops!"
        />
      </h2>
      <Copy.Simple
        id="app_tabs_monzo_me.common.error.server_error"
        fallback="Something went wrong on our end. Please try again later."
      />
    </div>
  )
}

export default class ErrorBoundary extends React.Component<Props, ErrorState> {
  override state = {
    error: null,
  }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  override componentDidCatch(
    error: Error,
    info: React.ErrorInfo | Record<string, unknown>,
  ) {
    captureSharedTabsException(error, info)
  }

  override render() {
    if (this.state.error != null) {
      return <ErrorText />
    }

    return <>{this.props.children}</>
  }
}
